// ------------- import xternal dependencies ------------
import { StateCreator } from "zustand";

// ----------- import internal dependencies -----------
import { IncidentSliceType } from "./incident.type";
import { FormAction, formReducer } from "./reducer";
import { TabOptions } from "../../types/fieldInstance.interface";
import { addToResetFnsSet } from "../store";

/**
 * incident state slice
 */
// Define the default state for each tab
const defaultTabState = {
  visited: false,
  isFormValid: false,
  isFormDirty: false,
};

// Function to create the default tabState object
function createDefaultTabState() {
  const state: {
    [key in Exclude<TabOptions, "Approvals">]: typeof defaultTabState;
  } = {} as any;
  Object.values(TabOptions).forEach((value) => {
    if (value !== TabOptions.Approvals) {
      state[value] = { ...defaultTabState };
    }
    if (value === TabOptions.Attachments) {
      state[value] = {
        ...defaultTabState,
        isFormValid: true,
      };
    }
  });
  return state;
}
const defaultFormState = {
  showPrompt: false,
  hasUnsavedChanges: false,
  shouldResetForm: false,
  savedStage: "",
  clickedStage: "",
  exitLink: "",
  tabState: createDefaultTabState(),
  incidentStatus: undefined,
  draftId: undefined,
  markedAsHighSeverity: false,
  markedHighSeverityInSession: false,
};

const formInitialState = {
  baseFormData: {
    idempotencyKey: "",
    incidentType: "",
    residentId: "",
    facilityId: "",
    guestName: "",
    agency: "",
    shiftWorked: "",
    unitAssignment: "",
    ssnLastFourDigits: "",
  },
  incidentFormData: null,
  deleteRelatedRecords: [],
  formState: defaultFormState,
};

const sliceInitialState = {
  forms: {},
  openIncidentClicked: false,
  editModeActive: false,
  isRlModalOpen: false,
  incidentsFromTrends: null,
};

const createIncidentSlice: StateCreator<IncidentSliceType> = (set) => {
  const reset = () => set(sliceInitialState);
  addToResetFnsSet(reset);
  return {
    ...sliceInitialState,
    setOpenIncidentClicked: (openIncidentClicked: boolean) =>
      set(() => {
        return { openIncidentClicked };
      }),
    setIsRlModalOpen: (isRlModalOpen: boolean) =>
      set(() => {
        return { isRlModalOpen };
      }),
    setIncidentsFromTrends: (incidentsFromTrends: any) =>
      set(() => {
        return { incidentsFromTrends };
      }),
    createForm: (formId, initialData = formInitialState) =>
      set((state) => ({
        forms: { ...state.forms, [formId]: initialData },
      })),

    updateForm: (formId: string, action: FormAction) =>
      set((state) => {
        const currentFormState = state.forms[formId];
        const updatedFormState = formReducer(currentFormState, action);
        return {
          forms: { ...state.forms, [formId]: updatedFormState },
        };
      }),
    resetForm: (formId) =>
      set((state) => {
        const updatedForms = { ...state.forms };
        delete updatedForms[formId];
        return { forms: updatedForms };
      }),
    resetIncident: reset,
  };
};

export default createIncidentSlice;
